import { z } from 'zod';
/**
 * The deprecated direct CSV import. `save` off is a dry run that reports what the rows would do;
 * `append` and `remove` say whether the rows add to the practice's list or take from it.
 */
export const FeedImportCsvSchema = z
    .object({
    practiceId: z.uuid(),
    csv: z.string().min(1),
    save: z.boolean().default(true),
    append: z.boolean().default(false),
    remove: z.boolean().default(false),
})
    .strict();
//# sourceMappingURL=importCsv.js.map